// extracted by mini-css-extract-plugin
export default {"kclSelectedClubType":"ClubType_kclSelectedClubType__y8frL","kclCheckIcon":"ClubType_kclCheckIcon__Q+vGT"};